// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ks9m7","requiredAsterisk":"Info_requiredAsterisk__3H9Vp"};